// File: packages/apps/workoutsmart/src/sync/workoutSessionSyncDriver.js
import { fetchResource } from '@platform/core/src/services/resourceApi';
import { applyPatchWithPartialProtection, mergeUpdateWithPartialProtection } from './syncUtils';

const workoutSessionSyncDriver = {
  async handleCreated(currentMap, content) {
    try {
      const newResource = await fetchResource(content.resource_type, content.resource_id);
      if (!newResource) return currentMap;
      const transformedResource = {
        ...newResource,
        type: 'workout_session',
        resource_type: 'workout_session',
      };
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (error) {
      return currentMap;
    }
  },

  handlePatched(currentMap, content) {
    const resourceToPatch = currentMap[content.resource_id];
    if (!resourceToPatch) return currentMap;

    try {
      const patchedResource = applyPatchWithPartialProtection(resourceToPatch, content.patches);
      const transformedResource = {
        ...patchedResource,
        type: 'workout_session',
        resource_type: 'workout_session',
      };
      return { ...currentMap, [content.resource_id]: transformedResource };
    } catch (e) {
      return currentMap;
    }
  },

  handleUpdated(currentMap, content) {
    const existingResource = currentMap[content.resource_id];

    const protectedValue = mergeUpdateWithPartialProtection(existingResource, content.value);
    const transformedValue = {
      ...protectedValue,
      type: 'workout_session',
      resource_type: 'workout_session',
    };
    return { ...currentMap, [content.resource_id]: transformedValue };
  },
};

export default workoutSessionSyncDriver;